module.exports = __webpack_public_path__ + "img/appstore.4588970a.svg";